module.exports = __webpack_public_path__ + "img/goto_icon.931998d1.svg";